import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface RegionOption {
  key: number;
  value: string;
}

export interface GetRegionListRequestParams {
  divisionKey?: number;
}

export const getRegionListAPI = (params?: GetRegionListRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetRegion`,
  });
};

export type RegionListResponse = RegionOption[];

export const fetchRegionList = async (params?: GetRegionListRequestParams): Promise<RegionListResponse> => {
  const response: AxiosResponse<RegionListResponse> = await getRegionListAPI(params);
  return response.data;
};
